import { useEffect, useState } from 'react';

export function useMatchMedia(query: string) {
  const [matches, setMatches] = useState<boolean>();

  useEffect(() => {
    const mqList = window.matchMedia(query);
    setMatches(mqList.matches);

    const changeListener = (event: MediaQueryListEvent) =>
      setMatches(event.matches);

    mqList.addEventListener('change', changeListener);
    return () => mqList.removeEventListener('change', changeListener);
  }, [query]);

  return matches;
}
